import { Component, OnInit, Input } from "@angular/core";
import { VideosService } from "src/app/core/services/videos.service";

interface Teacher {
  image: string;
  name: string;
  email: string;
}

@Component({
  selector: "app-course",
  templateUrl: "./course.component.html",
  styleUrls: ["./course.component.css"]
})
export class CourseComponent implements OnInit {
  @Input() video: string;
  @Input() image: string;
  @Input() date: Date = new Date();
  @Input() course: string;
  @Input() teacher: Teacher;

  constructor(private videosService: VideosService) {}

  ngOnInit() {}

  public onClick($event: Event) {
    console.log("Open vídeo", this.video);
    /* this.videosService.openVideo(this.video); */
  }
}
